import React from "react";
import "./WorkBanner.css";

// import your background image
import bg from "../../../../assets/images/services/hero.png";

const WorkBanner = () => {
  return (
    <section className="workbanner">
      
      {/* BACKGROUND IMAGE */}
      <img src={bg} alt="" className="workbanner__bg" />

      {/* DARK OVERLAY */}
      <div className="workbanner__overlay" />

      {/* CONTENT */}
      <div className="workbanner__content">
        <span className="workbanner__tag">Work</span>

        <h1>
          Products we’ve launched into <br />
          the real world
        </h1>

        <p>
          We design and build digital products that solve real problems, scale with growth,
          and deliver measurable results.
        </p>
      </div>

    </section>
  );
};

export default WorkBanner;